module.exports = __webpack_public_path__ + "static/images/r-gift-card.8957e99.png";